import {
  ButtonGroup,
  ButtonGroupCloseColorEnum,
  ButtonGroupCornerEnum,
  ButtonSizeEnum,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  HTMLElementTypeEnum,
  IconSizeEnum,
  Tooltip,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';

import { DELIVERY_STATES } from '@/helpers/delivery-states';
import { useParrillaFilters } from '@/stores/parrilla-filters';

export function BroadcastScheludeHeaderDeliveryFilter() {
  const { deliveryDate, setFilters } = useParrillaFilters();

  const handleDeliveryChange = (delivery: string) => {
    if (deliveryDate.includes(delivery)) {
      setFilters({ deliveryDate: deliveryDate.filter(p => p !== delivery) });
    } else {
      setFilters({ deliveryDate: [...deliveryDate, delivery] });
    }
  };

  return (
    <div className="flex items-center gap-2">
      {DELIVERY_STATES.map(item => (
        <Tooltip help={item.tooltip} key={item.value} grow>
          <ButtonGroup
            size={ButtonSizeEnum.SM}
            onClick={() => handleDeliveryChange(item.value)}
            onClickClose={() => handleDeliveryChange(item.value)}
            closeColor={ButtonGroupCloseColorEnum.PRIMARY}
            isFilled={deliveryDate.includes(item.value)}
            corner={ButtonGroupCornerEnum.FULL}
            className={clsx(
              'hover:!bg-neutral-20',
              deliveryDate.includes(item.value)
                ? '!border-[2px] !border-accent-active-primary-20 bg-extra-new-95'
                : '!border'
            )}
            closeIcon={deliveryDate.includes(item.value)}
          >
            <Typography
              element={HTMLElementTypeEnum.Span}
              fontSize={FontSizeEnum.Basic}
              weight={FontWeightEnum.Semibold}
              color={FontColorEnum.Dark10}
              className="flex items-center gap-1"
            >
              {<item.icon size={IconSizeEnum.SM} />}
            </Typography>
          </ButtonGroup>
        </Tooltip>
      ))}
    </div>
  );
}
